import BaseObject from '../../../../base/base_object';
import {SERIVCES_FUNC_LIST} from '../../native/native_const';
import {SYSTEM_EVENTS} from '../../../../events/events';
import _ from '../../../../utils/underscore';
import Device from '../../../../utils/device/device';
import Event from '../../../../utils/event';
import {LOGIN_TYPE} from '../../../oauth/oauth_const';

class Rating extends BaseObject {

    static CLASS = 'Rating';
    _hybridService = null;
    isFeatureEnable = false;
    init(params) {
        super.init();
        if (_.isNullOrUndefined(params)) {
            return;
        }
        if (Device.os.isIOS) {
            params = params.ios;
        } else if (Device.os.isAndroid) {
            params = params.android;
        }
        if (params.enable) {
            this.isFeatureEnable = true;
        }
    }

    initFeatures(hybridSrv) {
        this._hybridService = hybridSrv;
        if (this.isFeatureEnable) {
            this._subscribe();
        }
        return this;
    }

    _subscribe() {
        Event.on(SYSTEM_EVENTS.OAUTH_STATE_CHANGE, this.onOauthChange, this);
    }

    onOauthChange(params) {
        if ( this._hybridService.serviceFactory.oAuth2Service().isAuthorized() && ((params && params.loginType) === LOGIN_TYPE.NEW_LOGIN.toString())) {
            this.popUpRating();
        }
    }

    popUpRating() {
        this._hybridService.msgToHybrid(SERIVCES_FUNC_LIST.RATE_APP);
        this.logger.info('Rating PopUp Triggered');
    }
}

export default Rating;
